﻿export const eventListenerOnScroll = () => {

    let top  = window.pageYOffset || document.documentElement.scrollTop;
    //console.log(top);

    const docBody = document.querySelector("body");
    const header = document.querySelector("#siteHeader");
    const header_height = header.offsetHeight;
    

    const add_class_on_scrollPosition = () => docBody.classList.add("js-scrolled");
    const remove_class_on_scrollPosition = () => docBody.classList.remove("js-scrolled");

    if (top <= header_height) { remove_class_on_scrollPosition() }
    else { add_class_on_scrollPosition() }

    window.addEventListener("scroll", () => {

        var top  = window.pageYOffset || document.documentElement.scrollTop;
        if (top <= header_height) { remove_class_on_scrollPosition() }
        else { add_class_on_scrollPosition() }

    })


    
}